import React, {useEffect, useRef, useState} from 'react';
import {getLanguage, t} from 'react-switch-lang';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import Swal from 'sweetalert2';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from '../Metodologies/plus.png';
import CustomTable from '../../../components/customTable/CustomTable';
import {
  createRevisionTypes,
  deleteRevisionTypes, getAllRevisionTypes,
  updateRevisionTypes,
} from '../../../services/revisionTypes/revisionTypes';
import {validAbbriviationRegex} from '../../../utils/const';

const RevisionType = () => {
  const [revisionTypes, setRevisionTypes] = useState([])
  const [query, setQuery] = useState()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllRevisionTypes();
        setRevisionTypes(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      title: t('common.name'),
      editable: true,
      placeholder:`${t('common.placeholder.name')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 150, message: t('message.max', {max: 150})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('common.nameEn'),
      editable: true,
      placeholder:`${t('common.placeholder.nameEn')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 150, message: t('message.max', {max: 150})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'abbreviation',
      title: t('revisionTypes.abbreviation'),
      editable: true,
      placeholder:`${t('revisionTypes.abbreviationPlaceholder')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 3, message: t('message.max', {max: 3})},
        {pattern: validAbbriviationRegex, message: t('message.mustBeUppercaseWithoutDiacritics')},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
  ];
  const onUpdate = async (data, editingRecord, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    data.abbreviation = data.abbreviation.trim();
    data.id = editingRecord.id;
    try {
      const response = await updateRevisionTypes(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('message.updateSuccess2', {entity: t('revisionTypes.revisionType')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('revisionTypes.revisionTypesExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([

          {
            name: 'nameEn',
            errors: [t('revisionTypes.revisionTypesExists')],
          },
        ]);
      }
      else if (err.response.data.detail === "abbreviation") {
        form.setFields([
          {
            name: 'abbreviation',
            errors: [t('revisionTypes.abbreviationExists')],
          },
        ]);
      }
    }
  };

  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    data.abbreviation = data.abbreviation.trim();
    try {
      const response = await createRevisionTypes(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('message.addSuccess2', {entity: t('revisionTypes.revisionType')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('revisionTypes.revisionTypesExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([

          {
            name: 'nameEn',
            errors: [t('revisionTypes.revisionTypesExists')],
          },
        ]);
      }
      else if (err.response.data.detail === "abbreviation") {
        form.setFields([
          {
            name: 'abbreviation',
            errors: [t('revisionTypes.abbreviationExists')],
          },
        ]);
      }
    }
  };

  const onDelete = async (record) => {
    let response;
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('revisionTypes.revisionType'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
        confirmButtonText: t('common.delete2').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            response = await deleteRevisionTypes(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess2', {entity: t('revisionTypes.revisionType')}),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            if (err?.response?.data?.code === 'revision-type-could-not-be-deleted') {
              Swal.fire({
                text: t('message.revisionTypeCannotDelete'),
                icon: 'error',
              });
            } else {
              Swal.fire({
                text: t('message.deleteFailed', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
                icon: 'error',
              });
            }
          }
        }
      });
    });
  };

  const addButton = useRef();
  return (
    <div className="revisionTypes administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search">
          <SearchBox
            placeholder={t('revisionTypes.searchRevisionTypes')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('revisionTypes.add')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/revision-types"
        query={query}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        columns={columns}
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};
export default RevisionType;